import {Injectable} from "@angular/core";
import {WorkspaceServiceService} from "./workspace-service.service";
import {ChartInstanceService} from "./chartInstance/chart.instance.service";
import {AChartComponent} from "../components/achart/achart.component";
import {IOrdersData} from "../interfaces/service.response";
import {tradingLines} from "../model/tradingLines";
import {ChartDisplayMode} from "../enums/ChartDisplayMode.list";
import {MainUIServiceService} from "./main-uiservice.service";


@Injectable()
export class chartLinesService {

    public showTradeLines: IsingleChartTradeLines = {
        ach1: true,
        ach2: true,
        ach3: true,
        ach4: true
    }


    constructor(
        private service: WorkspaceServiceService,
        private chartInstanceService: ChartInstanceService,
        protected mainUIService:MainUIServiceService 
    ) {
        this.mainUIService.TabsActive.subscribe(v=>{
            this.updateTradeLines();
        })

        this.service.data.globaGridMode.chartPreloaderHide.subscribe(v=>{
            this.updateTradeLines();
        })
    }

    private _currentTrades: IOrdersData[] = [];
    public get currentTrades(): IOrdersData[] {

        if(this.service.data.activeTradeDeskTab == "_orders")
            {
                // this.currentOrders = this.currentOrdersStandard;
                return this._currentTrades.filter(v=>{
                    return !v.Type.includes(' ');
                 });;
            }
            else if(this.service.data.activeTradeDeskTab == "_ordersPending")
            {
                return this._currentTrades.filter(v=>{
                   return v.Type.includes(' ');
                });
            }
            else
            {
                return this._currentTrades=[];
            }

        return this._currentTrades;
    }
    public set currentTrades(value: IOrdersData[]) {
        // console.log("currentTrades");
        // console.log(value);
        this._currentTrades = value;
    }

    public listOfTrades: IOrdersData[] = [];

    public updateTradeLines() {
        this.chartInstanceService.charts.forEach((v: AChartComponent) => {

            if(this.service.data.mobileMode == "desktop") {
                this.loadOrderData(this.currentTrades, v);
            }
            else {
                if(v.itemID == "ach1") {
                    this.loadOrderData(this.currentTrades, v);
                }
            }
        })
    }

    public canShowLines:boolean = false;
    public loadOrderData(listOfTrades: IOrdersData[], chart: AChartComponent) {

        // if(!this.canShowLines || !this.service.data.showtradeLines)
        // {
        //     this.removeTradesLinesFromChart(chart);
        //     return;
        // }

        this.listOfTrades = listOfTrades;

        let needRedraw = false;
        if(!chart.canShowTrades || !chart.showLinesOnCurrentChart || !this.service.data.showtradeLines) {
            this.removeTradesLinesFromChart(chart);
            return;
        }

        let newItems: boolean = false;

        if(listOfTrades) {

            listOfTrades = this.listOfTrades.filter(k => {
                return k.Symbol == chart.symbol;
            });

            let mapIds: (string | undefined)[] = listOfTrades.map(k => {
                return k.Ticket
            })

            if(listOfTrades.length == 0) {
                this.removeTradesLinesFromChart(chart);
                return;
            }

            if(!this.service.data.showTradeDesk && chart.onHideTradeDeskAction) {
                this.removeTradesLinesFromChart(chart)
            }

            chart.tradingLines.forEach(v => {
                let index = -1;
                if(v.tempTradeData != null) {
                    index = mapIds.indexOf(v.tempTradeData.Ticket);
                }

                if(index == -1) {
                    this.removeTradesLinesFromChart(chart);
                }
            })

            chart.tradingLines = chart.tradingLines.filter(v => {
                return v.tempTradeData != null
            })


            listOfTrades.forEach(v => {
                let find = chart.tradingLines.find(k => {
                    if(k.tempTradeData != null) {
                        return k.tempTradeData.Ticket == v.Ticket
                    }
                    else {
                        return false
                    }
                });

                if(find) {
                    ////UPDATE
                    let needUpdate = false;

                  let index = chart.tradingLines.indexOf(find);
                    if(chart.tradingLines[index].tempTradeData!=null)
                    {
                    
                       if((chart.tradingLines[index].tempTradeData as IOrdersData).Limit!=v.Limit)
                       {
                            needUpdate =true
                       }

                       if((chart.tradingLines[index].tempTradeData as IOrdersData).Stop!=v.Stop)
                       {
                            needUpdate =true
                       }
                    }

                       if(needUpdate)
                       {
                        this.removeTradesLinesFromChart(chart);
                        let newTrade = new tradingLines(this.service.dataService, this.service.data);
                        newTrade.tempTradeData = v;
                        newTrade.chart = chart.chart;
                        chart.tradingLines.push(newTrade);
                        newItems = true;
                        needRedraw = true;
                       }
                   
                }
                else {
                    let newTrade = new tradingLines(this.service.dataService, this.service.data);
                    newTrade.tempTradeData = v;
                    newTrade.chart = chart.chart;
                    chart.tradingLines.push(newTrade);
                    newItems = true;
                    needRedraw = true;
                }


            })


        }

        if(needRedraw)
        this.drawTradeLinesAction(chart);




    }


    public removeLines() {
        this.chartInstanceService.charts.forEach((v: AChartComponent) => {
            this.removeTradesLinesFromChart(v)
        })
    }






    public drawTradeLinesAction(chart: AChartComponent) {

        if(!chart.showLinesOnCurrentChart) {

            return;
        }

        console.log("this.showLinesOnCurrentChart");
        console.log(chart.showLinesOnCurrentChart);
        if(!chart.workspace.showtradeLines && chart.workspace.mobileMode != "desktop") {
            return;
        }

        if(chart.workspace.mobileMode != "desktop" && chart.workspace.chartDisplayMode == ChartDisplayMode.ENTSIGNALS) {
            return;
        }


        if(chart.tradingLines.length > 0) {
            for(let k = 0; k < chart.tradingLines.length; k++) {
                this.drawTradeLineAtIndex(k, chart);
            }
        }
    }

    public removeTradesLinesFromChart(chart: AChartComponent) {

        for(let l = 0; l < chart.tradingLines.length; l++) {
            //     this.tradingLines[l].tempTradeData = null;
            chart.tradingLines[l].removeTradeLines();
        }
        chart.tradingLines = [];

    }


    public drawTradeLineAtIndex(index: number, chart: AChartComponent) {

        chart.tradingLines[index].backgroundColor(chart.BackgroundColor);
        chart.tradingLines[index].drawTradeLines(chart.tradingLines[index].tempTradeData);



        if(chart.tradingLines[index].marketPriceLine)
            chart.decorateAnnotation(<any> chart.tradingLines[index].marketPriceLine, index);

        if(chart.tradingLines[index].marketStopLine)
            chart.decorateAnnotation(<any> chart.tradingLines[index].marketStopLine, index);

        if(chart.tradingLines[index].marketLimitLine)
            chart.decorateAnnotation(<any> chart.tradingLines[index].marketLimitLine, index);


    }


    public drawActiveState() {
        this.updateTradeLines();
    }

    public resetTradeLines()
    {

        this.chartInstanceService.charts.forEach((v: AChartComponent) => {

            // if(this.service.data.mobileMode == "desktop") {
            //     this.loadOrderData(this.currentTrades, v);
            // }
            // else {
            //     if(v.itemID == "ach1") {
            //         this.loadOrderData(this.currentTrades, v);
            //     }
            // }
            v.canShowTrades = false;
            
        })
        
        this.drawActiveState();
        
    }
}

export interface IsingleChartTradeLines {
    [index: string]: boolean,

}